module.exports = __webpack_public_path__ + "media/images/home/location@2x-5e17ee8bf5200599ddcb9ea5b937a8c4.png";